import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import tranImg from "./../../components/images/Transactions.svg";
import { getGBussinessInfo, sendReceiptMail, numbermessage, getClassTransactionbyTid, getClassInvoicehtmlcontent, logEvent } from "../../services/classApiServices.js";
import Popup from "../../components/Popup";
import ReceiptPrint from "../../views/ReicptPrint";

import { format, parseISO } from "date-fns";
import {
    MDBBtn,
    MDBRadio,
    MDBModal,
    MDBModalDialog,
    MDBModalContent,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
    MDBCheckbox,
    MDBInput,
    MDBIcon,
    MDBDatatable,
    MDBAlert
} from 'mdb-react-ui-kit';
import logo from "../../components/images/easybook.png";
import Loader from "../../components/Loader";
import { formatDate } from "../../utils/DateFormat"
import copy from 'clipboard-copy';
import { createclassRefund, getWaiverSettingsbyGymid } from "../../services/apiServices";
import { sendMemberwaiverUrl } from "../../services/memberApiServices";
import { idToSlug } from "../../utils/slug";
import { browserName, browserVersion } from "react-device-detect";
import { useAnalytics } from "../../hooks/useAnalytics";

export default function ClassTransactionDetails(props) {
    const { trackButtonClick } = useAnalytics();
    let plansInfo = localStorage.getItem("planInfo") ? JSON.parse(localStorage.getItem("planInfo")) : null;
    const navigate = useNavigate();
    const [openPayment, setOpenPayment] = useState(false);
    const [openReceipt, setOpenReceipt] = useState(false);
    const [tData, setTData] = useState({});
    const [mem, setmem] = useState([]);
    const [loading, setLoading] = useState(true)
    const [transDate, setTransDate] = useState(new Date())
    const [smessage, setSMessage] = useState(false);
    const [basicModal, setBasicModal] = useState(false);
    const toggleOpen = () => setBasicModal(!basicModal);

    const [busData, setBusdata] = useState("");
    const [userdata, setUserdata] = useState([])
    const [mailData, setMailData] = useState([])
    const [selectedEmails, setSelectedEmails] = useState(mailData || []);
    const [OtherData, setOtherData] = useState("")
    const [invoiceUrl, setInvoiceUrl] = useState("");
    const [numberData, setNumberData] = useState([])
    const [selectedNumbers, setSelectedNumbers] = useState(numberData || []);
    const [selectType, setSelectType] = useState("email")
    const logourl = localStorage.getItem("loggedUserInfo") ? (JSON.parse(localStorage.getItem("loggedUserInfo")).gymlogoUrl ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymlogoUrl : logo) : logo;
    const [imageLoaded, setImageLoaded] = useState(true);
    const [apiError, setApiError] = useState(false);
    const [copyLink, setcopyLink] = useState(false);
    const [waiverLink, setWaiverLink] = useState("")
    const [sendLink, setSendLink] = useState(false)

    const handleWavierLink = () => {
        copy(waiverLink);
        setcopyLink(true);
    }


    useEffect(() => {

        const handleImageLoad = () => {
            setImageLoaded(true);
        };

        const handleImageError = () => {
            setImageLoaded(false);
        };
        const imgElement = document.createElement("img");
        imgElement.onload = handleImageLoad;
        imgElement.onerror = handleImageError;
        imgElement.src = logourl;

        return () => {
            imgElement.onload = null;
            imgElement.onerror = null;
        };
    }, [logourl]);
    console.log(props);
    async function fetchData(id, _id) {

        const response = await getClassTransactionbyTid(_id, props.gymid ? props.gymid : JSON.parse(localStorage.getItem("loggedUserInfo")).gymid);

        if (!response || response === "false") {
            return;
        }
        const record = await response.json();
        console.log(record, 'record');

        if (!record || record.length === 0) {

            navigate("/");
            return;
        }

        setInvoiceUrl(record.length > 0 ? record[0].url : "")
        setUserdata(record)
        console.log(record);
        // console.log(record && record.length > 0 ? record[0] : {});

        setTData(record && record.length > 0 ? record[0] : {});


        setmem(record && record.length > 0 ? record[0].membersid : []);

        const res = await getGBussinessInfo(props.gymid ? props.gymid : JSON.parse(localStorage.getItem("loggedUserInfo")).gymid, "class");
        if (!res || res === "false") {
            return;
        }
        const rec = await res.json();
        setBusdata(rec);
        setLoading(false)


    }
    useEffect(() => {

        fetchData(props.id, props.transid);
        // if (props.Rtoken) {
        //     setRtoken(false);
        // }
    }, [navigate, props]);
    function encryptId(id) {
        return btoa(id);
    }
    const [waiverid, setWaiverid] = useState("")
    async function fetchWaiverData() {

        const waiverRes = await getWaiverSettingsbyGymid(
            props.gymid ? props.gymid : JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
        );
        if (!waiverRes || waiverRes === "false") {
            // setApiError(true)
        } else {
            const waiver = await waiverRes.json();
            console.log(waiver);
            const trnsid = tData.tid ? tData.tid : -1
            const slug = encryptId(trnsid);
            console.log(slug, 'slug');
            let uniqueId = waiver?.uniqueNumber;
            setWaiverid(uniqueId)
            const encryptedId = encryptId(uniqueId);
            const link = `${window.location.origin}/classtranswaiver?id=${encryptedId}&tid=${slug}`
            console.log(link, 'link');
            setWaiverLink(link)
            // setWaiverForm(waiver)
        }
    }


    useEffect(() => {
        fetchWaiverData()
    }, [tData])
    async function processandReturn(event) {
        event.preventDefault();

        const htmlContent = await getClassInvoicehtmlcontent(tData.tid ? tData.tid : props.id, props.gymid ? props.gymid : JSON.parse(localStorage.getItem("loggedUserInfo")).gymid,)
        if (htmlContent === "false") {
            setApiError(true)
            return
        }
        const record = await htmlContent.json();

        console.log(record, '9999999999999999999');

        // Open a new window.
        const print_area = window.open('', '_blank');
        print_area.document.write(record.htmlContent);
        print_area.document.close();
        print_area.focus();
        setTimeout(() => {

            print_area.print();
        }, 500);
    }

    function handleTransdate(date) {
        console.log("in transdetails handleTransDate", date);
        setTransDate(date)
    }

    function gotohome() {
        cancelThis();
    }

    function cancelThis(event) {
        clearAll();
    }

    function clearAll() {
        window.location.reload(true);
        setOpenPayment(false);
        setOpenReceipt(false);
    }





    function handleClik(data) {
        console.log("hibhvdgsxh", data);
        if (props.filters == "mdetails") {
            props.oncancel()

        } else {

            let selMember = data.members

            localStorage.setItem("transaction_filter1", JSON.stringify(props.filters))
            selMember.Date11 = null;
            selMember.Date22 = null;
            selMember.TType = 3;
            selMember.addon = [];
            selMember.address = data.members && data.members.address ? data.members.address : "";
            selMember.age = data.members.age || "";
            selMember.anotherColumn = null;
            selMember.bId = data.members.bId;
            selMember.bloodgroup = data.members.bloodgroup || "";
            selMember.city = data.members.city || "";
            selMember.country = data.members.country || "";
            selMember.createdAt = data.members.createdAt;
            selMember.email = data.members.email || "";
            selMember.expirydate = data.members.expirydate;
            selMember.fname = data.members && data.members.fname;
            selMember.height = data.members && data.members.height ? data.members.height : null;
            selMember.lname = data.members && data.members.lname;
            selMember.mid = data.members.mid;
            selMember.member = data.members.member || "";
            selMember.number = data.members.number;
            selMember.others = data.members.others || "";
            selMember.plan = data.plan || [];
            selMember.planid = data.members.planid;
            selMember.referral = data.members.referral;
            selMember.sex = data.members.sex;
            selMember.startdate = data.members.startdate;
            selMember.updatedAt = data.members.updatedAt;
            selMember.weight = data.members.weight || null;
            selMember.__v = 0;
            selMember._id = data.members._id;
            selMember.return = "transactions"

            console.log(selMember);
            navigate("/mdetails", {
                state: selMember,
            });
        }
    }
    const [linkstatus, setLinkstatus] = useState("")
    const handleWaiverlink = async (memberid) => {

        const slug = idToSlug(memberid);
        console.log(slug, 'slug');
        let uniqueId = waiverid;
        const encryptedId = encryptId(uniqueId);
        const link = `${window.location.origin}/waiver?id=${encryptedId}&mId=${slug}`
        console.log(link, 'link');
        const update = {
            link: link,
            id: memberid,
            gymid: props.gymid ? props.gymid : JSON.parse(localStorage.getItem("loggedUserInfo")).gymid,
            centername: "testing"
        }
        const response = await sendMemberwaiverUrl(update)
        const data = await response.json();
        console.log(data, "data");
        if (data.success) {
            setLinkstatus('success')
        } else {
            setLinkstatus("danger")
        }
        setSendLink(true)
    }

    const handlecopyUrl = (memberid) => {
        const slug = idToSlug(memberid);
        console.log(slug, 'slug');
        let uniqueId = waiverid;
        const encryptedId = encryptId(uniqueId);
        const link = `${window.location.origin}/waiver?id=${encryptedId}&mId=${slug}`
        console.log(link, 'link');
        copy(link);

        setcopyLink(true);

    }
    let tmrow = [];
    mem && mem.forEach((itm) => {
        let rarray = [];
        rarray.push(itm.membername ? itm.membername : "UnKnown Name");
        rarray.push(itm.number ? itm.number : "UnKnown Number");
        rarray.push(
            tData && tData.itemprice ? tData.itemprice : 0
        );
        rarray.push(itm.discount ? itm.discount + "%" : "0%");
        rarray.push(itm.totalamount ? itm.totalamount : "0");
        if (props.from !== "member") {
            rarray.push(
                <div className='d-flex align-items-center'>
                    <div >
                        <span className='text-primary fw-300 me-2 cursor-pointer primary-icon' title="Copy"
                            onClick={() => handlecopyUrl(itm.id)}
                        ><i class="fa-regular fa-copy "></i></span>
                        <MDBBtn size="sm" className="ms-2" onClick={() => handleWaiverlink(itm.id)}>send</MDBBtn>
                    </div>
                </div >
            )
        }
        tmrow.push(rarray);
    });

    const basicData = {
        columns: [
            { label: "Members", field: "members", sort: false },
            { label: "Number", field: "number", sort: false },
            { label: "Actual price", field: "actualprice", sort: false },
            { label: "Discount", field: "discount", sort: false },
            { label: "Total Amount", field: "totalamount", sort: false },
            ...(props.from !== "member"
                ? [{ label: "Waiver", field: "waiver", sort: false }]
                : []),
        ],
        rows: tmrow,
    };




    const handleCheckboxEmailChange = (email) => {
        setSelectedEmails((prevSelectedEmails) => {
            if (prevSelectedEmails.includes(email)) {
                return prevSelectedEmails.filter((selectedEmail) => selectedEmail !== email);
            } else {
                return [...prevSelectedEmails, email];
            }
        });
    };
    const handleCheckboxNumberChange = (number) => {
        setSelectedNumbers((prevSelectedNumbers) => {
            if (prevSelectedNumbers.includes(number)) {
                return prevSelectedNumbers.filter((selectedNumber) => selectedNumber !== number);
            } else {
                return [...prevSelectedNumbers, number];
            }
        });
    };


    const handlesendReceipt = (e) => {
        e.preventDefault();
        // const uniqueEmailAddresses = ["tvamshif@gmail.com", "vamshibuss99@gmail.com"];
        console.log(userdata);
        trackButtonClick("ClassTransactiondetails", "Class_Transaction_Receipt", props.path == "member" ? "member" : "staff", {});
        console.log((JSON.parse(localStorage.getItem("loggedUserInfo"))).email);
        const uniqueEmailsSet = new Set();
        const uniqueNumbersSet = new Set()
        userdata.forEach(item => {

            if (item.member && item.member.length > 0 && item.member[0].email) {
                uniqueEmailsSet.add(item.member[0].email);
            }
            if (item.member && item.members.number) {
                uniqueNumbersSet.add(item.members.number)
            }

        });
        const uniqueEmailAddresses = Array.from(uniqueEmailsSet);
        uniqueEmailAddresses.push(localStorage.getItem("loggedUserInfo") ? (JSON.parse(localStorage.getItem("loggedUserInfo"))).email : "")
        const uniqueNumbers = Array.from(uniqueNumbersSet);
        uniqueNumbers.push(localStorage.getItem("loggedUserInfo") ? (JSON.parse(localStorage.getItem("loggedUserInfo"))).number : "")
        // console.log(uniqueEmailAddresses);
        setMailData(uniqueEmailAddresses)
        setSelectedEmails(uniqueEmailAddresses)
        setNumberData(uniqueNumbers)
        setSelectedNumbers(uniqueNumbers)
        toggleOpen()
    }




    const isValidEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const isValidPhoneNumber = (mobileNumber) => {
        // const mobileRegex = /^\d{10}$/;
        const mobileRegex = /^(?:(?:\+|0{0,2})91(\s*|[-])?|[0]?)?([6789]\d{2}([ -]?)\d{3}([ -]?)\d{4})$/;
        //6856438922
        //7856128945
        //8945562713
        //9998564723
        //+91-9883443344
        //09883443344
        //919883443344
        //0919883443344
        //+919883443344
        //+91-9883443344
        //0091-9883443344
        //+91 9883443344
        //+91-785-612-8945
        //+91 999 856 4723
        return mobileRegex.test(mobileNumber);
    };

    const sendReceipt = async (e) => {
        e.preventDefault();

        console.log(selectedEmails);
        console.log(selectedNumbers);
        console.log("OtherMails", OtherData);

        const uniqueEmailsSet = new Set([...selectedEmails]);
        const uniqueNumbersSet = new Set([...selectedNumbers]);

        const otherDataArray = OtherData.split(',').map(data => data.trim());
        let response = "";
        if (selectType === "email") {
            otherDataArray.forEach(email => uniqueEmailsSet.add(email));
            otherDataArray.forEach(email => {
                if (isValidEmail(email)) {
                    uniqueEmailsSet.add(email);
                } else {
                    console.log(`Invalid email format: ${email}`);
                }
            });
            uniqueEmailsSet.forEach(email => {
                if (!isValidEmail(email)) {
                    uniqueEmailsSet.delete(email);
                }
            });
            setMailData(Array.from(uniqueEmailsSet));

            // const content = recinf && recinf.length > 0 ? (recinf.length > 0 && recinf[0].Content) : "<p>Hello there<strong>!</strong> Below is the receipt for your most recent transaction. Please click on the download receipt button for the receipt. Feel free to click on the \"Download Receipt\" button to obtain your receipt. Appreciate your business!</p>"
            // console.log(content);

            const logo = localStorage.getItem("loggedUserInfo") ? (JSON.parse(localStorage.getItem("loggedUserInfo")).gymlogoUrl ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymlogoUrl : "") : "";

            console.log(logo, invoiceUrl, '77777777777777777777777777');

            let saverep = await sendReceiptMail(props.gymid ? props.gymid : JSON.parse(localStorage.getItem("loggedUserInfo")).gymid, Array.from(uniqueEmailsSet), invoiceUrl, (logo ? logo : "")
            );
            // console.log(saverep);

            const responseData = await saverep.json();
            response = responseData.sendEmail
            console.log(responseData);
            console.log("email sent successfully ");
        } else {
            const number = "6281619099"
            otherDataArray.forEach(number => uniqueNumbersSet.add(number));
            otherDataArray.forEach(number => {
                if (isValidPhoneNumber(number)) {
                    uniqueNumbersSet.add(number);
                } else {
                    console.log(`Invalid number format: ${number}`);
                }
            });
            uniqueNumbersSet.forEach(number => {
                if (!isValidPhoneNumber(number)) {
                    uniqueNumbersSet.delete(number);
                }
            });
            setNumberData(Array.from(uniqueNumbersSet));
            const respon = await numbermessage({ phone: number, url: invoiceUrl });
            console.log(respon);
            let resData = await respon.json();
            console.log(resData);
            response = resData.message
            console.log("sms sent successfully ");
        }
        toggleOpen()

        if (response === "success") {
            setSMessage(true);
            setTimeout(() => {
                setSMessage(false);
            }, 5000);
        }
        else {
            setSMessage(false);
        }
    };

    console.log(tData, tData.tid, 'transdate');
    // console.log(tData?.createdAt);
    const [confirmModal, setConfirmModal] = useState(false)
    const [refundRefresh, setRefundRefresh] = useState(false)
    const [policyData, setPolicyData] = useState({
        fee: { days: "", feevalue: "" },
        fromDays: 0,
        amount: 0,
    })
    const findNearestFee = (cancelfee, differenceInDays) => {
        const checkedFees = cancelfee
            .filter(fee => fee.checked)
            .map(fee => ({
                ...fee,
                days: parseInt(fee.days)
            }));


        if (checkedFees.length === 0) return null;

        const exactMatch = checkedFees.find(fee => fee.days === differenceInDays);
        if (exactMatch) return exactMatch;

        checkedFees.sort((a, b) => b.days - a.days);

        for (let i = 0; i < checkedFees.length; i++) {
            if (checkedFees[i].days <= differenceInDays) {
                return checkedFees[i];
            }
        }

        return checkedFees[checkedFees.length - 1];
    };


    const refundAlert = (e) => {
        // console.log(trans, 'trantrantrantrantran');
        const currentDate = new Date();

        const startDate = new Date(tData.startdate);

        const differenceInTime = startDate - currentDate;

        const differenceInDays = Math.ceil(differenceInTime / (1000 * 60 * 60 * 24));

        // console.log(`Days from now to startdate: ${differenceInDays}`);
        const matchingFee = tData?.cancelfee && tData?.cancelfee.length > 0
            ? findNearestFee(tData.cancelfee, differenceInDays)
            : null;
        console.log(differenceInDays, matchingFee, 'differenceInDays');
        let refundAmount = tData.totalamount;

        if (matchingFee && matchingFee.feevalue) {
            const feePercentage = parseFloat(matchingFee.feevalue);
            refundAmount = refundAmount - (refundAmount * feePercentage / 100);
            setPolicyData({
                fee: { days: matchingFee.days, feevalue: matchingFee.feevalue },
                fromDays: differenceInDays,
                amount: refundAmount,
            })
        } else {
            refundAmount = refundAmount;
            setPolicyData({
                fee: { days: differenceInDays, feevalue: 0 },
                fromDays: differenceInDays,
                amount: refundAmount,
            })
        }

        // console.log('Refund Amount:', refundAmount);


        setConfirmModal(true)
    }

    const handleConfirmRefund = async (e) => {

        e.preventDefault();

        const userInfo = JSON.parse(localStorage.getItem("loggedUserInfo")) || {};
        const fullName = userInfo.fname && userInfo.lname
            ? `${userInfo.fname} ${userInfo.lname}`
            : userInfo.name || "User";

        const username1 = userInfo.username || userInfo.email || "Guest";
        const gymid = userInfo.gymid || "";
        const ip = localStorage.getItem("ipaddress") || "Unknown IP";
        const browserinfo = `${browserName || "Unknown"}-${browserVersion || "0"}.0.0`;

        const Eventtype = username1;

        const flag = `Refund ₹${policyData.amount} by (${fullName})`;

        const update = {
            transid: tData._id,
            feeinfo: policyData.fee,
            refundamount: policyData.amount,
            refunddate: new Date(),
            paymentid: tData?.razorpay_order?.razorpay_payment_id
        }
        console.log(update, "update");

        const res = await createclassRefund(props.gymid ? props.gymid : JSON.parse(localStorage.getItem("loggedUserInfo")).gymid, update)


        await logEvent({
            Eventtype,
            username1,
            ip,
            flag,
            browserinfo,
            gymid,
            isclass: true
        }, gymid);
        await trackButtonClick("ClassTransactiondetails", "Class_Transaction_Refund", props.path == "member" ? "member" : "staff", {});
        // setRightOpen(true);
        setConfirmModal(false)
        setRefundRefresh(true)
        // setTimeout(() => setRightOpen(true), 100);
        fetchData(props.id, props.transid);

    }
    return (
        <>
            {loading && (<h4><Loader /></h4>)}
            <div>
                <div className="gym-container" id="showcase">
                    {smessage && (
                        <div>

                            <div id="snackbar-submit" className={`show-submit alert ${selectType === 'email' ? (mailData && mailData.length > 0 ? "alert-success" : "alert-danger") : (numberData && numberData.length > 0 ? "alert-success" : "alert-danger")} alert-fixed SentMailAllert w-30 mob-w-100`}>

                                <div className="text-left">
                                    {selectType === 'email' ? (mailData && mailData.length > 0 ? "Email sent successfully!!" : "Email not sent sentsuccessfully!! ") : (numberData && numberData.length > 0 ? "Sms sent successfully" : "Sms not sent successfully")}
                                    <div>
                                        {selectType === 'email' ? " Email(s):" : "Moblie Number(s):"}
                                    </div>
                                    <div>
                                        {selectType === 'email' && (mailData && mailData.length > 0 ? (
                                            <span>{mailData.join(', ')}</span>
                                        ) : (
                                            <span>No emails available</span>
                                        ))}
                                        {selectType === 'number' && (numberData && numberData.length > 0 ? (
                                            <span>{numberData.join(', ')}</span>
                                        ) : (
                                            <span>No number available</span>
                                        ))}

                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                </div>
                <div>

                    <>
                        <div className="d-flex align-items-center justify-content-between">
                            <p className="mb-1">Date</p>
                            <p className="mb-1 fw-600">{tData?.createdAt ? formatDate(tData.createdAt) : "UnKnown Date"}</p>
                        </div>
                        <div className="d-flex align-items-center justify-content-between">
                            <p className="mb-1">Transactions ID</p>
                            <p className="mb-1 fw-600">{tData.tid ? tData.tid : "Unknown Id"}</p>
                        </div>
                        {waiverLink && <div className="d-flex align-items-center justify-content-between">
                            <p className="mb-1">Transaction Wavier</p>
                            <p className="mb-1 fw-600 text-primary cursor-pointer" onClick={handleWavierLink} >  <u> <i class="far fa-copy me-1"></i> Wavier Link</u></p>
                        </div>}


                        <div className="d-flex align-items-center justify-content-between">
                            <p className="mb-1">Token Number</p>
                            <p className="mb-1 fw-600">
                                {tData?.token ? tData.token : "Unknown Token"}
                            </p>
                        </div>
                        <div className="d-flex align-items-center justify-content-between">
                            <p className="mb-1">Quantity</p>
                            <p className="mb-1 fw-600 d-flex align-items-center"><MDBIcon far icon="user" className="me-1  fs-10" />{tData?.quantity ? tData.quantity : 1
                            } </p>
                        </div>
                        
                        <div className="d-flex align-items-center justify-content-between">
                            <p className="mb-1">Total</p>
                            <p className="mb-1 fw-600">
                                <img src={tranImg} alt="paid" width="10" className="me-1" />
                                {tData?.totalamount ? tData.totalamount : "0"}
                            </p>
                        </div>
                        {tData?.refund?.refundamount && <div className="d-flex align-items-center justify-content-between">
                            <p className="mb-1">Refund Amount</p>
                            <p className="mb-1 fw-600">
                                <img src={tranImg} alt="paid" width="10" className="me-1" />
                                {tData?.refund?.refundamount ? tData?.refund?.refundamount : "0"}
                            </p>
                        </div>}
                        {tData?.refund?.refunddate && <div className="d-flex align-items-center justify-content-between">
                            <p className="mb-1">Cancel Date</p>
                            <p className="mb-1 fw-600">

                                {tData?.refund?.refunddate ? formatDate(tData?.refund?.refunddate) : "UnKnown Date"}
                            </p>
                        </div>}
                        <p className="mb-1">Member(s):</p>

                        {tData?.refund?.refundamount && <div className="p-2 alert alert-warning rounded-2 mb-2" role="alert">
                            <p className="m-0"><MDBIcon fas icon="sync-alt" color='warning' className='me-1' />The refund will be processed within 7 business days..!</p>

                        </div>}


                        <MDBDatatable data={basicData} className="Transaction__table sortOff" entries={25} />


                    </>

                </div>
            </div >
            <div className="modal-footer w-100">

                <p className="fs-small w-100  text-left">Note: All transactions are secure and encrypted</p>
                <div className="w-100 d-flex justify-content-between mx-0">
                    <div>

                        {props.from !== "member" && <button button type="button" className="btn btn-primary float-start me-1" member-mdb-dismiss="modal" onClick={(e) => processandReturn(e)}>
                            Print Receipt
                        </button>}
                        {props.from == "member" && <button type="button" className="btn btn-primary float-start me-1" member-mdb-dismiss="modal" onClick={() => props.downloadInvoice("class")}>
                            Download Invoice
                        </button>}
                        {props.from !== "member" && <button type="button" className="btn btn-primary float-start me-1" member-mdb-dismiss="modal" onClick={(e) => handlesendReceipt(e)}>
                            Send Receipt
                        </button>}



                    </div>
                    {(new Date(tData?.startdate) > new Date()) ?
                        <>{tData.status !== "refund" ?
                            <button type="button" className="btn btn-primary" member-mdb-dismiss="modal" onClick={(e) => refundAlert(e)}>
                                Cancel Session
                            </button> : <div> </div>}
                        </> : <></>
                    }

                    <button type="button" className="btn btn-secondary float-end" data-mdb-dismiss="modal" onClick={props.oncancel}>
                        Close
                    </button>

                </div>



                <MDBModal show={basicModal} setShow={setBasicModal} open={basicModal} setOpen={setBasicModal} tabIndex='-1'>
                    <MDBModalDialog>
                        <MDBModalContent>
                            <MDBModalHeader>
                                <MDBModalTitle>Send Reciept</MDBModalTitle>
                                <MDBBtn className='btn-close' color='none' onClick={toggleOpen}></MDBBtn>
                            </MDBModalHeader>
                            <MDBModalBody>
                                <div className="d-flex align-items-center mb-2">

                                    <MDBRadio
                                        name='inlineRadio'
                                        id='inlineRadio1'
                                        value='email'
                                        label='Email'
                                        inline
                                        checked={selectType === 'email'}
                                        onChange={() => {
                                            setSelectType('email')
                                            setOtherData("")
                                        }}
                                    />

                                </div>
                                {selectType === 'email' && mailData && mailData.length > 0 && mailData.map((email, index) => (
                                    <div key={index}>
                                        {email && <MDBCheckbox
                                            id={`flexCheckDefault${index}`}
                                            label={email}
                                            checked={selectedEmails.includes(email)}
                                            onChange={() => handleCheckboxEmailChange(email)}
                                        />}
                                    </div>
                                ))}
                                {selectType === 'number' && numberData && numberData.length > 0 && numberData.map((number, index) => (
                                    <div key={index}>
                                        {number && <MDBCheckbox
                                            id={`flexCheckDefault${index}`}
                                            label={number}
                                            checked={selectedNumbers.includes(number)}
                                            onChange={() => handleCheckboxNumberChange(number)}
                                        />}
                                    </div>
                                ))}
                                <div className="mt-2">
                                    <label>
                                        Enter other {selectType === 'number' ? "number" : "email"}(s):
                                    </label>
                                    <MDBInput value={OtherData} onChange={(e) => setOtherData(e.target.value)} />
                                    <p className="text-secondary m-0 mt-2">Note: To enter multiple {selectType === 'number' ? "number" : "email"}, use comma (,) separated values. </p>
                                </div>
                            </MDBModalBody>

                            <MDBModalFooter className="pe-4 pb-3">
                                <MDBBtn color='secondary' onClick={toggleOpen}>
                                    Close
                                </MDBBtn>
                                <MDBBtn
                                    disabled={mailData.length > 0 ? false : true}
                                    onClick={(e) => {
                                        sendReceipt(e)
                                    }}>Send</MDBBtn>
                            </MDBModalFooter>
                        </MDBModalContent>
                    </MDBModalDialog>
                </MDBModal>


                {openReceipt && (
                    <Popup
                        title="Print Receipt"
                        ptype="modal-lg"
                        content={
                            <>
                                <div>
                                    <ReceiptPrint gotohome={gotohome} transactionDate={transDate} />
                                </div>
                            </>
                        }
                        handleClose={gotohome}
                    />
                )}
                <MDBAlert
                    color='success'
                    autohide
                    position='top-right'
                    delay={2000}
                    appendToBody
                    open={copyLink}
                    onClose={() => setcopyLink(false)}
                >Link copied to clipboard!
                </MDBAlert>
                <MDBAlert
                    color={linkstatus}
                    autohide
                    position='top-right'
                    delay={2000}
                    appendToBody
                    open={sendLink}
                    onClose={() => setSendLink(false)}
                >{linkstatus == 'success' ? "Waiver send Successfully!" : "Waiver not send Successfully!"}
                </MDBAlert>
                <MDBModal tabIndex="-1" open={confirmModal} onClose={() => setConfirmModal(false)}>
                    <MDBModalDialog centered>
                        <MDBModalContent>
                            <MDBModalHeader>
                                <MDBModalTitle>Cancellation of Session</MDBModalTitle>
                                <MDBBtn className="btn-close" color="none" onClick={(e) => {
                                    e.stopPropagation();
                                    setConfirmModal(false);
                                }
                                }></MDBBtn>
                            </MDBModalHeader>
                            <MDBModalBody>
                                <p>Are you sure you want to cancel this session?</p>
                                <p>
                                    You will get <strong>₹{policyData.amount?.toLocaleString("en-IN") || "0.00"}</strong> refund according to the policy

                                </p>

                            </MDBModalBody>
                            <MDBModalFooter className="pe-2 pb-2">
                                <MDBBtn color="secondary" onClick={(e) => {
                                    e.stopPropagation();
                                    setConfirmModal(false);
                                }
                                }>
                                    Cancel
                                </MDBBtn>
                                <MDBBtn color="danger" onClick={(e) => {
                                    e.stopPropagation();
                                    handleConfirmRefund(e);
                                }}>
                                    Confirm
                                </MDBBtn>
                            </MDBModalFooter>
                        </MDBModalContent>
                    </MDBModalDialog>
                </MDBModal>
            </div>
        </>
    );
}